import { Injectable } from '@angular/core';
import { AppEventService, DataCacheService, RestDataService, UserService, UtilsService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';
import { BuilderList } from '../list-loader.service';
import { PumpsetDiffService } from '../pumpset-diff.service';

@Injectable({
  providedIn: 'root'
})
export class PumpsetBuilderFormService {

  constructor(private utils:UtilsService,
              private restDataService:RestDataService,
              private userService:UserService,
              private appEventService:AppEventService,
              private dataCacheService:DataCacheService,
              private pumpsetDiffService:PumpsetDiffService) {}

  savePumpset(pumpset:any){
    this.restDataService.post(environment.customPumpSetsURL,this.generatePostBody(pumpset)).subscribe(response=>{
      this.appEventService.emit({name:"SAVED",context:"pumpset",data:response});
    });
  }

  generateBoosterLayerForPost(boosterLayer){
    return {
      "BoosterId":this.boosterMatchesCachedOffical(boosterLayer)?boosterLayer.boosterId:"",
      "NumberOfBoostersInParallel":boosterLayer.numberOfBoostersInParallel,
      "hasUserBooster":!this.boosterMatchesCachedOffical(boosterLayer),
      "Pipework":boosterLayer.pipework,
      "UserBooster":this.boosterMatchesCachedOffical(boosterLayer)?{}:this.generateUserBooster(boosterLayer.boosterDetails,boosterLayer.hasUserBooster,boosterLayer.boosterId)
    }
  }

  generateBoosterLayersForPost(pumpset){
    let BoosterLayers=[];
    pumpset.pumpsetDetails.boosterLayersDetails.forEach(boosterLayer=>{
      BoosterLayers.push(this.generateBoosterLayerForPost(boosterLayer));
    });
    return BoosterLayers;
  }

  generateUserBooster(boosterDetails,isUserOrigin, boosterOriginId){
    let userBooster={...boosterDetails};
      userBooster.IsUserOrigin=isUserOrigin;
      userBooster.OriginId=boosterOriginId;
      userBooster.CreatorId=this.userService.getUser().userId;
      return userBooster;
  }

  generatePostBody(pumpset){        
    let transformedPumpset=this.utils.clone(pumpset);    
    delete transformedPumpset.id;
    let BoosterLayers=this.generateBoosterLayersForPost(transformedPumpset);
    transformedPumpset.pumpsetDetails.boosterLayersDetails.forEach(boosterLayer => {
      boosterLayer.pipework.forEach(pipe => {
        pipe.xDim1=pipe.xdim1;
        pipe.xDim2=pipe.xdim2;
        pipe.section=pipe.shapeSection=="Circular"?0:pipe.shapeSection=="Annular"?1:pipe.shapeSection=="Rectangular"?2:0;
        pipe.isFlexible=pipe.flexible==1
        pipe.selected=false;
      });
    });
    pumpset.name=this.pumpSetSaveName(this.cleanPumpSetName(pumpset.name));
    return {
      "Name":pumpset.name,
      "DataComment":this.generateAuditTrailNote(pumpset)+(pumpset.isUser?pumpset.dataComment:""),
      "CreatorId":this.userService.getUser().userId,
      "NumberOfBackingPumpsInParallel":pumpset.pumpsetDetails.numberOfBackingPumpsInParallel,
      "BackingPumpId":pumpset.pumpsetDetails.backingPumpId,
      "HasUserBackingPump":false,
      "NumberOfBoosterLayers":BoosterLayers.length,
      "BoosterLayers":BoosterLayers,
   };
  }

  cacheOfficialBoostersForPumpset(pumpset:any){
    this.dataCacheService.put(pumpset.id,this.utils.clone(pumpset));
    pumpset.pumpsetDetails.boosterLayersDetails.forEach(boosterLayer => {
      if(!boosterLayer.hasUserBooster){
        this.dataCacheService.put(boosterLayer.boosterId,this.utils.clone(boosterLayer.boosterDetails));
      }
    });
  }

  boosterMatchesCachedOffical(boosterLayer:any):boolean {
    if(boosterLayer.hasUserBooster) return false;
    let cachedOfficalBooster=this.dataCacheService.get<any>(boosterLayer.boosterId);
    if(!cachedOfficalBooster) return false;
    return boosterLayer.boosterDetails.initialFrequency === cachedOfficalBooster.initialFrequency 
    &&   boosterLayer.boosterDetails.userMaximumFrequency === cachedOfficalBooster.userMaximumFrequency &&
    boosterLayer.boosterDetails.pressureSwitch === cachedOfficalBooster.pressureSwitch &&   boosterLayer.boosterDetails.rootsId === cachedOfficalBooster.rootsId &&  boosterLayer.boosterDetails.rootsName === cachedOfficalBooster.rootsName &&   boosterLayer.boosterDetails.statorTemperature === cachedOfficalBooster.statorTemperature &&
    boosterLayer.boosterDetails.deltaTemperatureRotorStator === cachedOfficalBooster.deltaTemperatureRotorStator &&   boosterLayer.boosterDetails.driveId === cachedOfficalBooster.driveId &&  boosterLayer.boosterDetails.driveName === cachedOfficalBooster.driveName;
  }

  occurrenceOfThisSaveName(name:string):number{        
    let tree = this.dataCacheService.get<any>(BuilderList.Custom_Pumpset)    
    let count=0;
    if(!tree[0]) return count;
    tree[0].items.forEach(item => {
      count=this.cleanPumpSetName(item.name)==name?count+1:count;
    });
    return count;
  }

  cleanPumpSetName(name:string):string{
    let elements = name.split(' ');    
    let end =   elements[elements.length-1][0]=="("?name.length-(elements[elements.length-1].length-1)-2:name.length;  
    return name.substring(0,end);    
  }

  pumpSetSaveName(cleanPumpSetName:string){
    return cleanPumpSetName + (this.occurrenceOfThisSaveName(cleanPumpSetName)?" ("+(this.occurrenceOfThisSaveName(cleanPumpSetName)+1)+")":"");
  }

  generateAuditTrailNote(pumpset){   
    let original = this.dataCacheService.get(pumpset.id);    
    return "Original PumpsetId " + original['id'] + "</br>" 
    + "Original Name " + original['name'] + "</br>" 
    + "From " + (pumpset.isUser?"'My Pumpsets'":"'Official'") + "</br>"
    + "Changes: </br>"
    + this.pumpsetDiffService.diffToHTML(original,pumpset) + "</br>";
  }


}